import { render, staticRenderFns } from "./Conflict.vue?vue&type=template&id=4d3a3f14&scoped=true&"
import script from "./Conflict.vue?vue&type=script&lang=js&"
export * from "./Conflict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3a3f14",
  null
  
)

export default component.exports